var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"crumb"},[_c('el-breadcrumb',{attrs:{"separator":"/"}},_vm._l((_vm.path),function(item,index){return _c('el-breadcrumb-item',{key:index,attrs:{"to":index==_vm.path.length-1?null:{name:item.name}}},[_vm._v(_vm._s(item.meta.title))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }